import { Toggletip } from '@sainsburys-tech/fable'

interface IAppTooltipProps {
  message?: string
  value?: any
}

const AppTooltip = ({ message, value }: IAppTooltipProps) => (
  <Toggletip
    testid='app-tooltip'
    label='More information'
    message={
      <>
        {message}
        {value}
      </>
    }
    position='top'
    className='c-common-hide-in-print c-common-tooltip-blue'
  />
)

export default AppTooltip
